import { Transaction } from "../models/Transaction";
import PortUtils from "./PortUtils";
import Utils from "./PortUtils";

type TDateQuantity = [Date,number]
export default class DividendHistory {
    private _quantities:TDateQuantity[] = []
    private _dividends = new Map<number,number>()
    private _dividendsY = new Map<number,number>()

    constructor(transactions:Transaction[]) {
        let total : number = 0
        for(const trans of transactions){
            if (trans.isBuyOrSell) {
                total += trans.quantity
                this._quantities.push([trans.date,total])
            }
            else if (trans.isDividend){
                const year = trans.date.getFullYear()
                const yyyymm = this._yyyymm(trans.date)
                this._dividends.set(yyyymm, trans.quantity + (this._dividends.get(yyyymm) || 0))
                this._dividendsY.set(year, trans.quantity + (this._dividendsY.get(year)||0))
            }
        }
    }
    // find quantity upto a date
    quantity(date:Date){
        for(let i=this._quantities.length-1; i>=0; i--) {
            if (this._quantities[i][0]<date) {
                const q = this._quantities[i][1]
                return PortUtils.isZero(q) ? 0 : q
            }
        }
        return 0
    }
    // find dividend on a year/month +/- 1 month
    dividend(date:Date){
        return this._dividends.get(this._yyyymm(date)) 
            || this._dividends.get(this._yyyymm(date, 1))
            || this._dividends.get(this._yyyymm(date, -1))
            || 0
    }
    dividendOnMonth(date:Date){
        return this._dividends.get(this._yyyymm(date)) || 0
    }

    dividendOnYear(year:number){
        return this._dividendsY.get(year)||0
    }
    nextYearDividend(lastDividend:number, lastQuantity:number, quantity:number){
        return lastDividend/lastQuantity*quantity
    }
    get ytd(){return this.dividendOnYear(new Date().getFullYear())}
    get currentQuantity(){return this._quantities.length ? this._quantities[this._quantities.length-1][1] : 0 }

    private _yyyymm(date:Date, month:number=0){
        if (month) Utils.dateAdd(date, {month})
        return date.getFullYear()*100 + (date.getMonth()+1)
    }
}